/* VEXAR — pastille « Set Discount » sur les cartes produit.

   Une carte produit n'expose pas le type du produit dans le HTML.
   Ce script récupère une fois la liste des produits (/products.json),
   puis marque les cartes dont le type est Pack ou Ensemble avec la
   classe .vx-card-ensemble. Le CSS fait le reste.

   Résultat : tout nouvel ensemble reçoit sa pastille automatiquement,
   sans toucher au thème. Il suffit que son Type produit soit
   « Pack » ou « Ensemble ». */
(function () {
  'use strict';

  var TYPES = ['pack', 'ensemble'];
  var mapPromise = null;

  function getMap() {
    if (mapPromise) return mapPromise;
    mapPromise = fetch('/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        var m = {};
        (data.products || []).forEach(function (p) {
          m[p.handle] = String(p.product_type || '').toLowerCase();
        });
        return m;
      })
      .catch(function () { return {}; });
    return mapPromise;
  }

  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function tag(map) {
    var cards = document.querySelectorAll('product-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.getAttribute('data-vx-checked') === '1') continue;
      var h = handleOf(card);
      if (!h) continue;
      card.setAttribute('data-vx-checked', '1');
      if (TYPES.indexOf(map[h]) > -1) card.classList.add('vx-card-ensemble');
    }
  }

  function run() { getMap().then(tag); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var pending = null;
  try {
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; run(); }, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
